<template>
<h1 class="text-center">CSSPlugin</h1>
</template>

<script>
export default {
  name: "CSSPlugin"
}
</script>

<style scoped>

</style>